import ProductBar from './ProductBar';

function ProductDetails() {
    return (
        <div className='border border-[#EAEAEA] rounded-lg px-4 py-3 bg-[#FFFFFF] flex flex-col gap-2'>
            <h1 className='font-semibold text-base text-[#666666]'>Product Details</h1>

            <div className="flex flex-col">
                <div className="flex w-full uppercase bg-[#F5F5F5] font-semibold text-[14px] leading-6 text-[#666666]">
                    <h1 className='w-[46%] px-[10px] py-2'>product</h1>
                    <h1 className='w-[14%] px-[10px] py-2'>quantity</h1>
                    <h1 className='w-[17%] px-[10px] py-2'>rate per qty</h1>
                    <h1 className='w-[23%] px-[10px] py-2'>sku</h1>
                </div>

                <ProductBar />
            </div>
        </div>
    );
}

export default ProductDetails;
